import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import IconButton     from '@material-ui/core/IconButton';
import InputBase      from '@material-ui/core/InputBase';
import Paper          from '@material-ui/core/Paper';

import SearchIcon from '@material-ui/icons/Search';

const style = {
  attnedersFilter: makeStyles((theme) => ({
    root: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: 400,
    },
    iconButton: {
      padding: 10,
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
  })),
};

export default function AttendersFilter(props) {
  const classes = style.attnedersFilter();

  return (
    <Paper component="form" className={classes.root}>
      <IconButton className={classes.iconButton} aria-label="menu">
        <SearchIcon />
      </IconButton>
      <InputBase className={classes.input} 
        onChange={(event) => {
          props.setAttendersFilter((oldFilter) => ({
            ...oldFilter, keywords: event.target.value,
          }));
        }}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
          }
        }}
        value={props.attendersFilter.keywords}
      />
    </Paper>
  );
}